import React from 'react'

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
  useMatch,
  useSearchParams,
} from 'react-router-dom'
import Screens from './Screens'

import useReducer from '@store/useReducer'
import * as UserStore from '@store/user/user'
import * as AuthStore from '@store/auth/auth'
import { useSiteChangeHandler } from '@utils/useSiteChangeHandler'
import { extractHashParams } from '@layout/utils'

const ScreenAdapter = ({ screen }: { screen: ScreenDefinition }) => {
  const location = useLocation()
  const match = useMatch({ path: screen.path })
  const [search] = useSearchParams()

  const matchParams = match?.params || {}
  const params = location.state || {}

  const query = Object.fromEntries(search)
  const hash = extractHashParams(location.hash)

  return <screen.screen screen={screen.name} {...params} {...matchParams} {...query} {...hash} />
}

const NotFound = ({ path }: { path: string }) => <Navigate replace to={path} />

const MainLayout = () => {
  const logged = useReducer(UserStore.store, (s) => s.logged)
  const user = useReducer(UserStore.store, (s) => s.user)
  const scopes = useReducer(AuthStore.store, (s) => s.scopes)
  const tokens = useReducer(AuthStore.store, (s) => s.tokens)

  useSiteChangeHandler()

  const SCRS = Object.values(Screens)
    .filter((s) => !!s.auth === logged)
    .filter((s) => !s.scopes || !!s.scopes.find((scp) => scopes.includes(scp)))

  return (
    <Router>
      <Routes>
        {SCRS.map((s) => (
          <Route path={s.path} key={s.name} element={<ScreenAdapter screen={s} />} />
        ))}

        <Route
          path="*"
          element={<NotFound path={`${logged && !!tokens ? (user ? '' : '/incident/start') : '/login'}`} />}
        />
      </Routes>
    </Router>
  )
}

export default MainLayout
